<template>
  <NuxtLink :to="$localePath('/')" class="logo image-switcher">
    <transition name="logo-fade" mode="out-in">
      <!-- emblem -->
      <div v-if="currentIndex === 0" key="logo-emblem" class="emblem-text">
        <div class="symbol">
          <img src="/images/logo/logo_emblem_2nd_symbol.svg">
        </div>
        <!-- 한영서포 : 이미지 -->
        <div v-if="locale === 'ko'" class="texts">
          <img src="/images/logo/logo_emblem_2nd_ko.svg" alt="어머니 사랑과 평화의 날 - 2주년 - Since 2024">
        </div>
        <div v-else-if="locale === 'en'" class="texts">
          <img src="/images/logo/logo_emblem_2nd_en.svg" alt="어머니 사랑과 평화의 날 - 2주년 - Since 2024">
        </div>
        <div v-else-if="locale === 'es'" class="texts">
          <img src="/images/logo/logo_emblem_2nd_es.svg" alt="어머니 사랑과 평화의 날 - 2주년 - Since 2024">
        </div>
        <div v-else-if="locale === 'pt'" class="texts">
          <img src="/images/logo/logo_emblem_2nd_pt.svg" alt="어머니 사랑과 평화의 날 - 2주년 - Since 2024">
        </div>
        <!-- 기타 언어 : 텍스트 -->
        <div v-else class="texts">
          <div class="title" v-html="$t('어머니사랑과평화의날로고')" />
          <div class="sub" v-html="`<span class='number'>${$t('2em주년')}</span> <span>${$t('since2024')}</span>`" />
        </div>
      </div>

      <!-- logo -->
      <img
        v-else
        key="logo-main"
        class="img"
        :src="`/images/logo/logo_${
          [
            'bn',
            'cn',
            'cs',
            'de',
            'el',
            'en',
            'es',
            'fil',
            'fr',
            'gu',
            'hi',
            'hu',
            'id',
            'ja',
            'km',
            'kn',
            'ko',
            'ml',
            'mn',
            'ms',
            'my',
            'ny',
            'ne',
            'or',
            'pt',
            'ro',
            'ru',
            'si',
            'ta',
            'te',
            'th',
            'trp',
            'vi',
            'zh',
          ].includes(locale)
            ? locale
            : 'en'
        }.svg`"
        alt="어머니 사랑과 평화의 날 로고"
      >
    </transition>
  </NuxtLink>
</template>

<script lang="ts" setup>
// // 로고 & 엠블럼 번갈아 보이기
import { onBeforeUnmount, onMounted, ref } from 'vue'

const { locale } = useI18n()

const currentIndex = ref(0)
let intervalId: ReturnType<typeof setInterval> | null = null

onMounted(() => {
  intervalId = setInterval(() => {
    currentIndex.value = (currentIndex.value + 1) % 2 // 2개의 이미지
  }, 10000) // 10초
})

onBeforeUnmount(() => {
  if (intervalId) {
    clearInterval(intervalId)
  }
})
</script>
